<template>
	<div>
		<HomeHeader></HomeHeader>
		<section>

			<HomeHero />

			<div class="diagonalBackgroundLeft">
				<div class="section steps">
					<div class="wp1200">
						<h3>{{ $t("home.main_text5") }}</h3>
						<div class="flex">
							<div class="col1_3">
								<div class="shift">
									<div class="imageHeight">
										<img src="@/assets/images/landingPageJoinNow.svg" />
									</div>
									<div class="underImageContent">
										<span class="bigNum">{{ $t("home.number1") }}</span>
										<div class="text">
											<span class="title">{{ $t("home.login_button") }}</span>
											<hr class="short" />
											<p v-html="$t('home.main_text6')"></p>
										</div>
									</div>
								</div>
							</div>
							<div class="col1_3">
								<div class="shift">
									<div class="imageHeight">
										<img src="@/assets/images/landingPageParticipate.svg" />
									</div>
									<div class="underImageContent">
										<span class="bigNum">{{ $t("home.number2") }}</span>
										<div class="text">
											<span class="title">{{ $t("home.main_text9") }}</span>
											<hr class="short" />
											<p>{{ $t("home.main_text7") }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col1_3">
								<div class="shift">
									<div class="imageHeight">
										<img src="@/assets/images/landingPageEarn.svg" />
									</div>
									<div class="underImageContent">
										<span class="bigNum">{{ $t("home.number3") }}</span>
										<div class="text">
											<span class="title">{{ $t("home.main_text10") }}</span>
											<hr class="short" />
											<p>{{ $t("home.main_text8") }}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<img src="@/assets/images/greenLeft.svg" class="greenLeft" />
			</div>
			<div class="section awards">
				<div class="wp630">
					<h3>{{ $t("home.main_text11") }}</h3>
					<p class="subTitle">{{ $t("home.main_text12") }}</p>
				</div>
				<img src="@/assets/images/awards.jpg" id="awards" />
				<router-link :to="{ name: 'login', query: { page: 'register' } }">
					<a class="join hoverEffect" ref="joinButton2"
						v-on:mouseover="formUtilsMouseHoverEffect($event, 'joinButton2')"
						v-on:mouseout="formUtilsMouseHoverEffect($event, 'joinButton2')">
						<label>{{ $t("home.login_button") }}</label>
						<span class="effect" ref="effectButton2"
							v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"></span>
						<img src="@/assets/images/nextArrowAnimation.svg" />
					</a>
				</router-link>
			</div>
			<div class="diagonalBackgroundRight">
				<div class="section charityPoints">
					<div class="wp630">
						<h3>{{ $t("home.main_text13") }}</h3>
						<span>{{ $t("home.main_text14") }}</span>
						<p>{{ $t("home.main_text15") }}</p>
						<img src="@/assets/images/landingPageHeart.png" />
					</div>
				</div>
				<img src="@/assets/images/greenLeft.svg" class="greenRight responsiveLeft" />
			</div>
			<div class="section prizeDraws">
				<h3 class="responsiveShow">{{ $t("home.main_text16") }}</h3>
				<div class="wp1200 flex">
					<div class="col1_2">
						<img src="@/assets/images/landingPageDrum.svg" />
					</div>
					<div class="col1_2 text">
						<h3 class="responsiveHide">{{ $t("home.main_text16") }}</h3>
						<span>{{ $t("home.main_text17") }}</span>
						<p>{{ $t("home.main_text18") }}</p>
					</div>
				</div>
				<router-link :to="{ name: 'login', query: { page: 'register' } }">
					<a class="join hoverEffect" ref="joinButton3"
						v-on:mouseover="formUtilsMouseHoverEffect($event, 'joinButton3')"
						v-on:mouseout="formUtilsMouseHoverEffect($event, 'joinButton3')">
						<label>{{ $t("home.login_button") }}</label>
						<span class="effect" ref="effectButton3"
							v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"></span>
						<img src="@/assets/images/nextArrowAnimation.svg" />
					</a>
				</router-link>
			</div>

			<div class="section accordion wp1200">
				<h3 class="withBorder">{{ $t("home.accordion_title") }}</h3>
				<Accordion></Accordion>

				<router-link :to="{ name: 'login', query: { page: 'register' } }">
					<a class="join hoverEffect" ref="joinButton4"
						v-on:mouseover="formUtilsMouseHoverEffect($event, 'joinButton4')"
						v-on:mouseout="formUtilsMouseHoverEffect($event, 'joinButton4')">
						<label>{{ $t("home.login_button") }}</label>
						<span class="effect" ref="effectButton4"
							v-bind:style="{ top: topX + 'px', left: leftX + 'px' }"></span>
						<img src="@/assets/images/nextArrowAnimation.svg" />
					</a>
				</router-link>
			</div>

			<div class="landingFooter wp1200">
				<div class="flex">
					<div class="content">
						<p v-html="$t('home.main_text19')"></p>

						<img class="esomar" src="@/assets/images/esomar-2024.png" />
					</div>

					<div class="data">
						<strong>Episcenter d.o.o.</strong><br />
						Bravničarjeva 13<br />
						1000 Ljubljana<br />
						Slovenija<br /><br />
						E: <a href="mailto:info@episcenterklub.si" target="_blank">info@episcenterklub.si</a><br />
						T: <a href="tel:+38614702600" target="_blank">+386 1 470 26 00</a>
					</div>
				</div>
			</div>
		</section>

		<Cookies />

	</div>
</template>

<script>
import HomeHeader from "./partials/HomeHeader";
import Accordion from "./partials/Accordion";
import Cookies from "@/components/Cookies";
import HomeHero from './partials/HomeHero.vue'
import { formUtilsMouseHoverEffect } from '@/utils/form_utils.js';

export default {
	data() {
		return {
			topX: 1,
			leftX: 1,
			notCompleted: true,
		};
	},
	mounted() {

	},
	methods: {
		formUtilsMouseHoverEffect,
	},
	components: {
		Cookies,
		HomeHeader,
		Accordion,
		HomeHero,
	},
};
</script>

<style>
a {
	text-decoration: none !important;
}
</style>